import { createFeatureSelector, createSelector } from "@ngrx/store";
import { HomeState } from "./home.reducer";

export const homeFeatureKey = 'home';
export const selectHomeFeature = createFeatureSelector<HomeState>(homeFeatureKey);

export const selectTrainData = createSelector(
    selectHomeFeature,
    state => state.trainData
)

export const selectFetchingTrainData = createSelector(
    selectHomeFeature,
    state => state.fetchingTrainData
)

export const selectFetchingMessageData = createSelector(
    selectHomeFeature,
    state => state.fetchingMessageData
)

export const selectMessageData = createSelector(
    selectHomeFeature,
    state => state.messageData
)

